import { render, staticRenderFns } from "./CalculationPage.vue?vue&type=template&id=29924054"
import script from "./CalculationPage.vue?vue&type=script&lang=js"
export * from "./CalculationPage.vue?vue&type=script&lang=js"
import style0 from "./CalculationPage.vue?vue&type=style&index=0&id=29924054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports